import { Typography } from '@mui/material';
import { styled } from '@mui/system'
import { getAnalytics, logEvent } from "firebase/analytics";

import { location } from '../../../../assets/images/svgs';

const AddressContainer = styled('div')((props) => (
    {
        display: 'flex',
        flexDirection: 'row',
        background: "#849C6A",
        color: 'white',
        padding: '10px',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 18,
        [props.theme.breakpoints.up(620)]: {
            display: 'none'
        }
    }
))

export const Address = () => {
    const analytics = getAnalytics();
    const onClickLocation = () => {
        logEvent(analytics, 'on_click_location')
        window.location.href = 'https://goo.gl/maps/P6YWaKVxW3G2ZGcZ6'
    }

    return(
    <AddressContainer onClick={onClickLocation}>
        <Typography style={{ marginLeft: 4, marginRight:2 }}>Meet Us:</Typography>
        {location}
        <Typography style={{ marginLeft: 4 }}>68p,Sector 46, Gurgaon</Typography>
    </AddressContainer>)}